export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/yellow-plan-badge.9a3f39f0.svg","height":88,"width":92};